/**
 * WebSmReject — the dead-end "door is closed" screen (ported from Glow's
 * WebSmReject_type.jsx). Options: Title / Message / ReconsiderLabel / BgColor
 *   / AccentColor. Emits CLICK1 (Reconsider).
 */
import {
  CARD_CLASS,
  LINK_BTN_CLASS,
  MESSAGE_CLASS,
  SECTION_CLASS,
  stepVars,
} from "./step-shell";
import type { StepTypeProps } from "./types";

export default function WebSmRejectType({ getOpt, dispatch }: StepTypeProps) {
  const bg = getOpt("BgColor") || "#0a0809";
  const accent = getOpt("AccentColor") || "#d6a94e";

  const title = getOpt("Title") || "The door is closed.";
  const message = getOpt("Message") || "That's where most people's story ends.";
  const reconsiderLabel = getOpt("ReconsiderLabel") || "Reconsider";

  return (
    <section
      style={stepVars({ accent, bg })}
      className={`${SECTION_CLASS} px-4 py-12`}
    >
      <div className={CARD_CLASS}>
        {/* red, not the usual bone — this is the one screen that says no */}
        <div className="mb-4 text-[22px] leading-[1.32] font-bold text-[#d8635c] [text-shadow:0_0_18px_rgba(216,99,92,.3)]">
          {title}
        </div>

        {message ? <div className={MESSAGE_CLASS}>{message}</div> : null}

        {reconsiderLabel ? (
          <button
            type="button"
            onClick={() => dispatch("CLICK1")}
            className={LINK_BTN_CLASS}
          >
            {reconsiderLabel}
          </button>
        ) : null}
      </div>
    </section>
  );
}
